import styled from 'styled-components';
import { Form } from 'antd';

export const FormEvents = styled(Form)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;
